module.exports = __webpack_public_path__ + "static/media/1005256.8b2e47f7.jpg";